/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterCardRequest as AgentApiContractRegisterCardRequest } from '../../models/AgentApi/Contract/register-card-request';
import { RegisterCardResponse as AgentApiContractRegisterCardResponse } from '../../models/AgentApi/Contract/register-card-response';

export interface ApiAgentRegisterCardPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiContractRegisterCardRequest
}

export function apiAgentRegisterCardPost(http: HttpClient, rootUrl: string, params?: ApiAgentRegisterCardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentRegisterCardPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractRegisterCardResponse>;
    })
  );
}

apiAgentRegisterCardPost.PATH = '/api/Agent/RegisterCard';
